export default "__VITE_ASSET__BjWnknqg__"